import { render, staticRenderFns } from "./editonpurchase.vue?vue&type=template&id=24b3d9c5&scoped=true&"
import script from "./editonpurchase.vue?vue&type=script&lang=js&"
export * from "./editonpurchase.vue?vue&type=script&lang=js&"
import style0 from "./editonpurchase.vue?vue&type=style&index=0&id=24b3d9c5&scoped=true&lang=scss&"
import style1 from "./editonpurchase.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b3d9c5",
  null
  
)

export default component.exports